<script context="module">
  import { onMount } from "svelte";
  import tippy from "tippy.js";
  import "tippy.js/dist/tippy.css";

  export function tooltip(node, title) {
    // the node has been mounted in the DOM

    const tippiInstance = tippy(node, {
      content: title,
      allowHTML: true,
    });

    return {
      update(title) {
        tippiInstance.setContent(title);
      },

      destroy() {
        tippiInstance.destroy();
      },
    };
  }
</script>

<script>
  export let title = null;
  export let color = "#0389cc";

  let contentEl;

  let el;

  $: tooltipTitle = title || contentEl?.textContent;
</script>

<span
  style="--tooltip-anchor-color:{color};"
  bind:this={el}
  class="t-icon-question-sign tooltip-target"
  rel="tooltip"
  use:tooltip={tooltipTitle}
/>

<!-- Just to provide human friendly interface for tooltip body -->
<div style="display:none;" bind:this={contentEl}>
  <slot />
</div>

<style>
  .tooltip-target {
    padding-left: 0;
    padding-right: 0;
    color: #0389cc;
    color: var(--tooltip-anchor-color);
    cursor: help;
  }
</style>
